export default {"src":"/_next/static/media/ic-view.0ad95f35.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};